/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacCapricorn = createLucideIcon("zodiac-capricorn", [
  ["path", { d: "M11 21a3 3 0 0 0 3-3V6.5a1 1 0 0 0-7 0", key: "1kkncs" }],
  ["path", { d: "M7 19V6a3 3 0 0 0-3-3h0", key: "1jg5y1" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
]);

export { ZodiacCapricorn as default };
//# sourceMappingURL=zodiac-capricorn.js.map
